/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import Url from 'url-parse'

import './styles.scss'

class AccountNavigation {
  constructor (element) {
    this.$el = $(element)
    this.$menuItems = this.$el.find('.account-navigationLink')

    this.setActiveItem = this.setActiveItem.bind(this)

    $(window).on('hashchange', this.setActiveItem)
    this.setActiveItem()
  }

  setActiveItem () {
    const currentURL = new Url(window.location.href, true)
    const menuHeader = this.$el.find('.account-navigationItem--menuHeader h4')

    this.$menuItems.each(function () {
      $(this).parent('li').removeClass('account-navigationItem--active')
      const updatedPath = new Url(this.href, true)

      if (`${updatedPath.origin}${updatedPath.pathname}` === `${currentURL.origin}${currentURL.pathname}` && updatedPath.hash === currentURL.hash) {
        const updateHeaderContent = $(this).text()
        menuHeader.text(updateHeaderContent)

        $(this).parent('li').addClass('account-navigationItem--active')
      }
    })
  }
}

registerClass('AccountNavigation', AccountNavigation)
